import _extends from "@babel/runtime/helpers/extends";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { observable, computed, action } from 'mobx';
import { API_STATE, LANGUAGE } from "../../constants/index.js";
import { mapInitialStateToStoreState, flow } from "../../utils/store.utils/index.js";
import { GoogleTranslationClient } from "../../clients/google-translation.client.js";
/**
 * GoogleTranslationStore
 */
var GoogleTranslationStore = (_dec = action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   */
  function GoogleTranslationStore(initialState) {
    if (initialState === void 0) {
      initialState = {};
    }
    _initializerDefineProperty(this, "data", _descriptor, this);
    _initializerDefineProperty(this, "API_STATE", _descriptor2, this);
    /**
     * fetch GoogleTranslation
     * @param {Function} errorHandler
     */
    _initializerDefineProperty(this, "fetch", _descriptor3, this);
    this.updateInitialState(initialState);
  }
  var _proto = GoogleTranslationStore.prototype;
  /**
   * update initial state
   * @param {Object} initialState
   */
  _proto.updateInitialState = function updateInitialState(initialState) {
    mapInitialStateToStoreState(this, initialState);
  };
  /**
   * handle success
   * @param {Object} data
   */
  _proto.onSuccess = function onSuccess(data) {
    this.data.push(data);
    this.API_STATE = API_STATE.SUCCESS;
  }

  /**
   * handle error
   * @param {Object} error
   * @param {Function} errorHandler
   */;
  _proto.onError = function onError(error, errorHandler) {
    errorHandler(error);
    this.API_STATE = API_STATE.FAILED;
  };
  _createClass(GoogleTranslationStore, [{
    key: "isLoading",
    get:
    /**
     * is loading
     * @return {boolean}
     */
    function get() {
      return this.API_STATE === API_STATE.LOADING;
    }

    /**
     * is fetched
     * @return {boolean}
     */
  }, {
    key: "isFetched",
    get: function get() {
      return this.API_STATE === API_STATE.SUCCESS;
    }

    /**
     * has error
     * @return {boolean}
     */
  }, {
    key: "hasError",
    get: function get() {
      return this.API_STATE === API_STATE.FAILED;
    }

    /**
     * translation map
     */
  }, {
    key: "translationsMap",
    get: function get() {
      return this.data.reduce(function (translations, res) {
        var _extends2;
        return _extends({}, translations, (_extends2 = {}, _extends2[res.remarks] = res.translation, _extends2));
      }, {});
    }
  }]);
  return GoogleTranslationStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "API_STATE", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return API_STATE.INITIAL;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFetched", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFetched"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "translationsMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "translationsMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateInitialState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fetch", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return flow(function (_ref) {
      var _this = this;
      var string = _ref.string,
        language = _ref.language,
        _ref$errorHandler = _ref.errorHandler,
        errorHandler = _ref$errorHandler === void 0 ? function () {
          return null;
        } : _ref$errorHandler;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var shouldFetch, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              shouldFetch = language === LANGUAGE.AR && !_this.translationsMap[string];
              if (shouldFetch) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _this.API_STATE = API_STATE.LOADING;
              _context.prev = 4;
              _context.next = 7;
              return GoogleTranslationClient.translate({
                string: string
              });
            case 7:
              response = _context.sent;
              _this.onSuccess(response);
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](4);
              _this.onError(_context.t0, errorHandler);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 11]]);
      })();
    });
  }
}), _applyDecoratedDescriptor(_class.prototype, "onSuccess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype)), _class));
export { GoogleTranslationStore as default };